<template>
  <div class="services_recommd container">
    <div class="container-head">
      <div class="head-left">
        <div class="icon">
          <img :src="title.icon" />
        </div>
        {{ title.title }}
      </div>
    </div>
    <div class="services_list">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6" v-for="item in compayservicelist" :key="item.id">
          <div
            class="services_item"
            @click="selectType($event)"
            :data-title="item.title"
            :class="item.bgpath != '' ? 'bg' : ''"
          >
            <img v-if="item.bgpath == ''" :src="item.iconpath" />
            <div class="name">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogFormVisible" width="7rem">
      <div class="common_poup">
				<div class="poup_banner">
					<img src="../../static/poup/banner.png" />
				</div>
				<div class="box">
					<div class="box_title">
						<img class="title_icon" src="../../static/poup/icon.png" />填写信息
					</div>
					<div class="dbox_cell">
						<div class="dbox_name">姓名</div>
						<div class="dbox_input"><input type="text" v-model="leads.name"  placeholder="请输入" class="input"></input></div>
					</div>
					<div class="dbox_cell">
						<div class="dbox_name">手机号码</div>
						<div class="dbox_input"><input type="text"  maxlength="11" v-model="leads.tel"  placeholder="请输入" class="input"></input></div>
					</div>
					<div class="dbox_cell">
						<div class="dbox_name">需求描述</div>
						<div class="dbox_input"><textarea class="textarea" v-model="leads.otherdesc"  placeholder="请输入"></textarea></div>
					</div>

					<div class="btn_save" @click="btn_save">提交</div>
				</div>
			</div>
    </el-dialog>
  </div>
</template>

<script>
import { getleads } from "../view/api/api"; //引入api里面定义的方法
export default {
  props: ["compayservicelist", "title"],
  data() {
    return {
      dialogFormVisible: false,
      leads: {
					name:'',
					tel:'',
					otherdesc:''
				}
    };
  },
  methods: {
    selectType(e) {
      //console.log(e);
      //console.log(e.target.innerText);
      var title = e.target.innerText;
      var _slef = this;
      _slef.service = title;
      _slef.dialogFormVisible= true
      //this.$refs.mychild.open();
    },
    async btn_save() {

				var _self = this
                var data = _self.leads
                var phone_reg = /^1[3456789]\d{9}$/
				if (data.name == '') {

					
                    this.$toast('请输入名字')
					return false
				}
				if (data.tel == '') {

				
                    this.$toast('请输入电话')
					return false
				}else{
					if (!phone_reg.test(data.tel)) { 
						
                        this.$toast('手机号码格式错误')
						return false
					}
				}

				var parm = {
					tel: data.tel,
					name: data.name,
					otherdesc: data.otherdesc,
					service: this.service,
				}

				const res = await getleads(parm)
				if (res.status == 1) {
                
         this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.leads.name = ''
							_self.leads.tel = ''
                            _self.leads.otherdesc = ''
                            _self.dialogFormVisible= false
					
				}
			},
  }
};
</script>

<style lang="less" scoped>
.common_poup {
		width: 100%;
		height:auto;
		background-color: #ffffff;
		border-radius: 0rem;
		flex-direction: column;

		.poup_banner {
			width: 100%;
			height: 2rem;
            overflow: hidden;

			img {
				width: 100%;
				
			}
		}

		.box {
			margin: 0.2rem auto;
			width: 96%;
			height: auto;
			flex-direction: column;

			.box_title {
				font-size: 0.16rem;
				line-height: 0.25rem;
				margin-bottom: 0.2rem;
                align-items: center;
                display: flex;
                align-items: center;
                
                 @media (max-width: 991px) {
                        font-size: 0.32rem;
                        line-height: 0.42rem;
                        height: auto;
                    }

				.title_icon {
					width: 0.18rem;
					height: 0.18rem;
					margin-right: 0.1rem;
                     @media (max-width: 991px) {
                        width: 0.28rem;
                        height: 0.28rem;
                        
                    }
				}
			}

			.dbox_cell {
				align-items: center;
				justify-content: space-between;
                margin-bottom: 0.2rem;
                display: flex;

				.dbox_name {
					width: 1.25rem;
					height: 0.25rem;
					font-size: 0.16rem;
					color: #5E5E66;
					line-height: 0.25rem;
					text-align: justify;
					display: inline-block;
                    @media (max-width: 991px) {
                        font-size: 0.28rem;
                        line-height: 0.33rem;
                        height: auto;
                    }
					// text-align-last: justify;
				}

				.dbox_input {
					width: 4.63rem;

					.input {
						width: 3.83rem;
						line-height: 0.24rem;
						padding: 0.1rem 0.12rem;
						background: rgba(196, 196, 204, 0.1);
                        border-radius: 0rem;
                        border:0.01rem solid #ccc;
						font-size: 0.16rem;
						color: #333;
                         @media (max-width: 991px) {
                        font-size: 0.28rem;
                        line-height: 0.33rem;
                        height: auto;
                        padding: 0.17rem 0.12rem;
                    }
					}

					.textarea {
						width: 3.83rem;
						height: 1rem;
						line-height: 0.25rem;
						padding: 0.1rem 0.12rem;
						background: rgba(196, 196, 204, 0.1);
						border-radius: 0rem;
                        border:0.01rem solid #ccc;
						font-size: 0.16rem;
						color: #333;
                        resize: none;
                         @media (max-width: 991px) {
                        font-size: 0.28rem;
                        line-height: 0.33rem;
                        height: auto;
                        padding: 0.17rem 0.12rem;
                    }
					}

					.select {
						width: 100%;
						height: 0.66rem;
						border: 0;
						background-color: rgba(196, 196, 204, 0.1);
                         @media (max-width: 991px) {
                        font-size: 0.28rem;
                        line-height: 0.33rem;
                        height: auto;
                    }
					}
				}
			}

			.btn_save {
				margin: 0.5rem auto 0 auto;
				width: 2.7rem;
				height: 0.7rem;
				line-height: 0.7rem;
                border-radius: 0.35rem;
				background: #1395ff;
				font-size: 0.24rem;
				color: #FFFFFF;
				align-items: center;
				justify-content: center;
                 @media (max-width: 991px) {
                        font-size: 0.28rem;
                       
                    }
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/serviceslist.vue